module.exports = __webpack_public_path__ + "static/media/breifcase.848d6bc8.svg";